import Model from "../Model";

class Comercialmessage extends Model{

    buildUrl ({ param }) {
        return ['internalmessage/getmessagebyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Comercialmessage;